<!--
  Lleva las direcciones de antes a las de ahora, con `replace` para que atrás
  no vuelva a la vieja. Ver `legacyPath` en `lib/legacyPaths.ts`.
-->
<script lang="ts">
  import { legacyPath } from "../lib/legacyPaths";
  import { location, navigate } from "../lib/router.svelte";

  $effect(() => {
    const target = legacyPath(location.pathname);
    if (target)
      navigate(`${target}${location.search}${location.hash}`, { replace: true, instant: true });
  });
</script>
